/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export const GTM_EVENT_SIDEBAR_COLLAPSE = 'interaction_builder_sidebar_collapse';
export const GTM_EVENT_SIDEBAR_UNCOLLAPSE = 'interaction_builder_sidebar_expand';
export const GTM_EVENT_SELECT_PRESET = 'interaction_builder_select_preset';
export const GTM_EVENT_ZOOM = 'interaction_builder_zoom';
export const GTM_EVENT_BACK = 'interaction_builder_back';
export const GTM_EVENT_NEXT = 'interaction_builder_next';
export const GTM_EVENT_COPY_CODE = 'interaction_builder_copy_code';
export const GTM_EVENT_LANGUAGE = 'interaction_builder_language';
export const GTM_EVENT_LOG_IN = 'interaction_builder_log_in';
export const GTM_EVENT_SIGN_UP = 'interaction_builder_sign_up';
export const GTM_EVENT_LOGGED_IN = 'interaction_builder_logged_in';
export const GTM_EVENT_SIGNED_UP = 'interaction_builder_signed_up';
export const GTM_EVENT_SIGNED_OUT = 'interaction_builder_signed_out';
export const GTM_EVENT_UPGRADE_PLAN = 'interaction_builder_upgrade';
export const GTM_EVENT_SEARCH = 'interaction_builder_search';
export const GTM_EVENT_STACKBLITZ = 'interaction_builder_stackblitz';
export const GTM_EVENT_DOWNLOAD = 'interaction_builder_download';
export const GTM_EVENT_OUTPUT = 'interaction_builder_output';
export const GTM_EVENT_GROUP_SELECT = 'interaction_builder_group_select';
export const GTM_EVENT_FEATURE_SELECT = 'interaction_builder_feature_select';
export const GTM_EVENT_PLUGIN_SELECT = 'interaction_builder_plugin_select';
export const GTM_EVENT_GROUP_TOGGLE = 'interaction_builder_group_toggle';
export const GTM_EVENT_GROUP_COLLAPSE = 'interaction_builder_group_collapse';
export const GTM_EVENT_GROUP_UNCOLLAPSE = 'interaction_builder_group_expand';
export const GTM_EVENT_START_OVER = 'interaction_builder_start_over';
export const GTM_EVENT_CONTINUE = 'interaction_builder_continue';
export const GTM_EVENT_TOGGLE_PREVIEW = 'interaction_builder_toggle_preview';
export const GTM_EVENT_CHANGE_TECHNOLOGY = 'interaction_builder_technology';
export const GTM_EVENT_CHANGE_INTEGRATION = 'interaction_builder_integration';
export const GTM_EVENT_MAIN_TOOLBAR_COLLAPSE = 'interaction_builder_m_toolbar_wrapped';
export const GTM_EVENT_MAIN_TOOLBAR_MENU_BAR = 'interaction_builder_m_toolbar_menu_bar';
export const GTM_EVENT_MAIN_TOOLBAR_MENU_BAR_OPTION = 'interaction_builder_menu_bar_option';
export const GTM_EVENT_BALLOON_TOOLBAR = 'interaction_builder_balloon_toolbar';
export const GTM_EVENT_BLOCK_TOOLBAR = 'interaction_builder_block_toolbar';
export const GTM_EVENT_LOGO = 'interaction_builder_logo';
export const GTM_EVENT_CLOSE = 'interaction_builder_close';
export const GTM_EVENT_EDITOR_FOCUS = 'interaction_builder_editor_focus';
export const GTM_EVENT_EDITOR_BLUR = 'interaction_builder_editor_blur';
export const GTM_EVENT_INSTALLATION_SUMMARY = 'interaction_builder_installation_summary';
export const GTM_EVENT_CONVERSION = 'interaction_builder_conversion';
export const GTM_EVENT_TOGGLE_VIEW = 'interaction_builder_toggle_view';
export const GTM_EVENT_STEP = 'interaction_builder_step';
